import { FormStatus } from '@atlassian/proforma-common-core/form-system-models';
const formStatusMapping = {
  [FormStatus.Locked]: 'locked',
  [FormStatus.Submitted]: 'submitted',
  [FormStatus.Open]: 'open'
};
export const getSimpleFormAnalytics = (formId, projectFormId, status, internal) => ({
  formId,
  templateFormId: projectFormId,
  formStatus: status && formStatusMapping[status],
  visibility: internal === undefined ? 'unknown' : internal ? 'internal' : 'external'
});